import Vue from 'vue';
import axios from '../plugins/axios';

// 后台请求统一前缀，可以根据需要用多种前缀区分不同类型的接口
const apiPrefix = '/api'
// const apiPrefix = 'http://10.190.65.49:9010'

const api = {
	user: {
		getUserInfo() {
			return axios.get(`${apiPrefix}/login/info`)
		}
	},
	// 建立新邮件草稿，默认为创建新邮件
	createNewEmailDart({ SourceEmailId, Operate }) {
		return axios.post(`${apiPrefix}/emails/id/draft`, {
			data: {
				SourceEmailId,
				Operate
			}
		})
	},
	// 文件上传
	fileUploader(params) {
		return axios.post(`${apiPrefix}/email/fileupload`, params)
	},
	/* 获取用户信息 */
	getUserInfoByToken: (params) => {
		return axios.get(`${apiPrefix}/login/info`, {
			headers: {
				token: params,
			},
			params: params,
		});
	},
	/* 获取邮件列表 */
	getEmaList: (params) => {
		return axios.post(`${apiPrefix}/emails`, { data: params });
	},
	/* 批量设置阅读状态 */
	setReadStatusByIds: (params) => {
		return axios.put(`${apiPrefix}/emails/ids/batch-read`, params)
	},
	/* 获取邮箱未读数 */
	getEmaNotRead: (params) => {
		return axios.get(`${apiPrefix}/folders/unreademailscount`, { params: params, })
	},
	/* 获取文件夹 */
	getFolderList: () => {
		return axios.get(`${apiPrefix}/folders`)
	},
	/* 批量删除 */
	deletEMAList: (params) => {
		return axios.delete(`${apiPrefix}/emails/ids`, { data: params })
	},
	// 搜索联系人
	contactSearch(params) {
		return axios.post(`${apiPrefix}/contact/searchmailuser`, params)
	},
	// 获取文件预览地址
	getFilePreviewUrl(params) {
		return axios.get(`${apiPrefix}/openoffice/geturl`, { params })
	},
	// 获取邮件详情
	getEmailDetail(params) {
		return axios.post(`${apiPrefix}/emails/id?id=${params['Id']}`, { data: params })
	},
	// 获取联系人用户信息
	getContacterInfo(email) {
		return axios.post(`${apiPrefix}/contact/getuserinfo`, { email })
	},
	// 会议邮件回复操作
	meetingResponse(params) {
		return axios.post(`${apiPrefix}/appointments/respondappointment`, params)
	},
	// 获取微信配置 /wechat/getJsapiTicket
	getSignature(params) {
		return axios.get(`${apiPrefix}/wechat/getJsapiTicket`, {
			params
		})
	},
	// 发送邮件
	sendEmail(params) {
		return axios.post(`${apiPrefix}/email`, { data: params })
	},
	// 保存草稿
	saveEmailDarft(params) {
		return axios.post(`${apiPrefix}/emails/id/draft/save`, { data: params })
	},
	//批量设置文件夹下邮件阅读状态数据模型  '
	changeStatusByFolderId(params) {
		return axios.put(`${apiPrefix}/emails/folder/id/batch-read`, params)
	},
	// 根据工号指获取用户信息
	getUserinfoByEmpNo(params) {
		return axios.post(`${apiPrefix}/contact/getbyempnos`, { data: params })
	},
	// 附件删除
	deleteAttachment(params) {
		return axios.post(`${apiPrefix}/emails/attachments/delete-attachment`, { data: params })
	},
	/* 获取邮件列表 */
	getEmaListApp: (params) => {
		return axios.post(`${apiPrefix}/emailsForApp`, { data: params });
	},
	// 获取邮件详情
	translate: (params) => {
		return axios.post(`${apiPrefix}/translate/xingrui`, { data: params });
	},
  // 增加埋点日志
  traceUserInfo() {
		return axios.get(`${apiPrefix}/login/record`)
	},

};

Vue.api = api;
Vue.prototype.$api = api;

export default api;
